import Page from "../Common/Page";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import React, { ReactNode } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Popconfirm,
  Space,
  Table,
  message,
} from "antd";
import { userTypeCodeODK_SU, userTypeCodeUNIV_SU } from "../Common/AppSettings";
import { AuthContext } from "../Auth/Auth";
import { http } from "../Common/http";
import { Messages } from "../Common/ValidateMessages";
import { NavigateFunction } from "react-router-dom";
import withRouterDom from "../Common/WithReactRouterDom";

type FormData = {
  universityCode: string;
  facultyId: string;
  departmentId: string;
  majorId: string;
  courceId: string;
  userTypeCode: string;
  seiMei: string;
  seiMeiKana: string;
  mailAddress: string;
};

interface Props {
  navigation: NavigateFunction;
  location: any;
}
interface UserSearchRequestBean {
  universityCode: string;
  mailAddress: string | undefined;
  seiMei: string | undefined;
  seiMeiKana: string | undefined;
  userTypeCode: string | undefined;
  facultyId: string | undefined;
  departmentId: string | undefined;
  majorId: string | undefined;
  courceId: string | undefined;
}
interface UserSearchResponseBean {
  userId: string;
  userAccount: string;
  seiMei: string;
  seiMeiKana: string;
  mailAddress: string;
  userTypeCode: string;
  userTypeName: string;
  facultyName: string;
  departmentName: string;
  majorName: string;
  courceName: string;
}
interface UserDeleteRequestBean {
  userId: string;
}
interface ResultBean {
  result: string;
}

export class UserList extends React.Component<Props> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;

  state = {
    universityCode: "",
    userList: [],
    page: 1,
    pageSize: 10,

    facultyId: undefined,
    departmentId: undefined,
    majorId: undefined,
    courceId: undefined,
    userTypeCode: undefined,
    mailAddress: undefined,
    seiMei: undefined,
    seiMeiKana: undefined,
  };

  constructor(props: Props) {
    super(props);
    this._page = React.createRef<Page>();
    this._form = React.createRef();

    const { location } = this.props;
    this.state = {
      universityCode: location.state?.universityCode
        ? location.state?.universityCode
        : "",
      userList: [],
      page: 1,
      pageSize: 10,
      facultyId: location.state?.facultyId
        ? location.state?.facultyId
        : undefined,
      departmentId: location.state?.departmentId
        ? location.state?.departmentId
        : undefined,
      majorId: location.state?.majorId ? location.state?.majorId : undefined,
      courceId: location.state?.courceId ? location.state?.courceId : undefined,
      userTypeCode: location.state?.userTypeCode
        ? location.state?.userTypeCode
        : undefined,
      mailAddress: location.state?.mailAddress
        ? location.state?.mailAddress
        : undefined,
      seiMei: location.state?.seiMei ? location.state?.seiMei : undefined,
      seiMeiKana: location.state?.seiMeiKana
        ? location.state?.seiMeiKana
        : undefined,
    };
  }

  componentDidMount = async () => {
    if (this.context.user.userTypeCode !== userTypeCodeODK_SU) {
      this.setState({
        universityCode: this.context.user.universityCode,
      });
    }
    const { location } = this.props;
    if (location.state) {
      this.searchUserList();
    }
  };

  // 選択項目変更
  onChangeUniversityCode = (newValue: any) => {
    this.setState({
      universityCode: newValue !== undefined ? newValue.value : undefined,
    });
  };
  onChangeUserTypeCode = (newValue: any) => {
    this.setState({
      userTypeCode: newValue !== undefined ? newValue.value : undefined,
    });
  };
  onChangeFacultyId = (newValue: any) => {
    this._form.current.setFieldsValue({
      departmentId: undefined,
      majorId: undefined,
      courceId: undefined,
    });
    this.setState({
      facultyId: newValue !== undefined ? newValue.value : undefined,
      departmentId: undefined,
      majorId: undefined,
      courceId: undefined,
    });
  };
  onChangeDepartmentId = (newValue: any) => {
    this._form.current.setFieldsValue({
      majorId: undefined,
      courceId: undefined,
    });
    this.setState({
      departmentId: newValue !== undefined ? newValue.value : undefined,
      majorId: undefined,
      courceId: undefined,
    });
  };
  onChangeMajorId = (newValue: any) => {
    this._form.current.setFieldsValue({
      courceId: undefined,
    });
    this.setState({
      majorId: newValue !== undefined ? newValue.value : undefined,
      courceId: undefined,
    });
  };
  onChangeCourceId = (newValue: any) => {
    this.setState({
      courceId: newValue !== undefined ? newValue.value : undefined,
    });
  };

  // 検索処理
  searchUserList = async () => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      // backend通信し、ユーザ登録
      const postData: UserSearchRequestBean = {
        universityCode: this.state.universityCode,
        mailAddress: this.state.mailAddress,
        seiMei: this.state.seiMei,
        seiMeiKana: this.state.seiMeiKana,
        userTypeCode: this.state.userTypeCode,
        facultyId: this.state.facultyId,
        departmentId: this.state.departmentId,
        majorId: this.state.majorId,
        courceId: this.state.courceId,
      };
      const result = await http<
        UserSearchResponseBean[],
        UserSearchRequestBean
      >({
        path: "/User/search",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      if (result.ok) {
        this.setState({ userList: result.body });
      } else {
        message.error(Messages["ERR-020"]);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-020"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };
  deleteUser = async (userId) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      // backend通信し、ユーザ登録
      const postData: UserDeleteRequestBean = {
        userId: userId,
      };
      const result = await http<ResultBean, UserDeleteRequestBean>({
        path: "/User/delete",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body?.result === "1") {
        this._page.current?.setState({ isPageLoading: false });
        this.searchUserList();
      } else {
        message.error(Messages["ERR-020"]);
        this._page.current?.setState({ isPageLoading: false });
      }
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-020"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };
  // 検索ボタン押す
  onSearch = (data: FormData) => {
    this.setState({
      mailAddress: data.mailAddress,
      seiMei: data.seiMei,
      seiMeiKana: data.seiMeiKana,
    });
    this.searchUserList();
  };
  // 編集ボタン押す
  onEdit = (user: any) => {
    const { navigation } = this.props;
    navigation("/UserRegister/" + user.userId, {
      state: {
        universityCode: this.state.universityCode,
        mailAddress: this.state.mailAddress,
        seiMei: this.state.seiMei,
        seiMeiKana: this.state.seiMeiKana,
        userTypeCode: this.state.userTypeCode,
        facultyId: this.state.facultyId,
        departmentId: this.state.departmentId,
        majorId: this.state.majorId,
        courceId: this.state.courceId,
      },
    });
  };
  // 削除ボタン押す
  onDelete = async (user: any) => {
    this.deleteUser(user.userId);
  };
  // パスワードリセットボタン押す
  onResetPw = (user: any) => {
    const { navigation } = this.props;
    navigation("/ResetPw/" + user.userId, {
      state: {
        universityCode: this.state.universityCode,
        mailAddress: this.state.mailAddress,
        seiMei: this.state.seiMei,
        seiMeiKana: this.state.seiMeiKana,
        userTypeCode: this.state.userTypeCode,
        facultyId: this.state.facultyId,
        departmentId: this.state.departmentId,
        majorId: this.state.majorId,
        courceId: this.state.courceId,
      },
    });
  };
  columns = [
    {
      title: <div className="table-title">ユーザアカウント</div>,
      dataIndex: "userAccount",
      key: "userId",
      width: "15%",
    },
    {
      title: <div className="table-title">氏名</div>,
      dataIndex: "seiMei",
      key: "seiMei",
    },
    {
      title: <div className="table-title">氏名（カナ）</div>,
      dataIndex: "seiMeiKana",
      key: "seiMeiKana",
    },
    {
      title: <div className="table-title">メールアドレス</div>,
      dataIndex: "mailAddress",
      key: "mailAddress",
    },
    {
      title: <div className="table-title">ユーザ種別</div>,
      dataIndex: "userTypeName",
      key: "userTypeName",
    },
    {
      title: <div className="table-title">学部</div>,
      dataIndex: "facultyName",
      key: "facultyName",
    },
    {
      title: <div className="table-title">学科</div>,
      key: "departmentName",
      dataIndex: "departmentName",
    },
    {
      title: <div className="table-title">専攻</div>,
      key: "majorName",
      dataIndex: "majorName",
    },
    {
      title: <div className="table-title">コース</div>,
      key: "courceName",
      dataIndex: "courceName",
    },
    {
      title: "",
      key: "action",
      render: (text: any, record: any) =>
        this.context.user.userTypeCode === userTypeCodeODK_SU ||
        (record.userTypeCode !== userTypeCodeUNIV_SU &&
          record.userTypeCode !== userTypeCodeODK_SU) ? (
          <Space size="middle" direction="vertical">
            <Button
              type="primary"
              htmlType="button"
              onClick={() => this.onEdit(record)}
            >
              編集
            </Button>
          </Space>
        ) : (
          ""
        ),
    },
    {
      title: "",
      key: "action",
      render: (text: any, record: any) =>
        this.context.user.userTypeCode === userTypeCodeODK_SU ||
        (record.userTypeCode !== userTypeCodeUNIV_SU &&
          record.userTypeCode !== userTypeCodeODK_SU) ? (
          <Space size="middle" direction="vertical">
            <Popconfirm
              title="ユーザを削除してもよろしいですか？"
              okText="はい"
              cancelText="いいえ"
              onConfirm={() => this.onDelete(record)}
            >
              <Button type="primary" htmlType="button">
                削除
              </Button>
            </Popconfirm>
          </Space>
        ) : (
          ""
        ),
    },
    {
      title: "",
      key: "action",
      render: (text: any, record: any) =>
        this.context.user.userTypeCode === userTypeCodeODK_SU ||
        (record.userTypeCode !== userTypeCodeUNIV_SU &&
          record.userTypeCode !== userTypeCodeODK_SU) ? (
          <Space size="middle" direction="vertical">
            <Button
              type="primary"
              htmlType="button"
              onClick={() => this.onResetPw(record)}
            >
              パスワードリセット
            </Button>
          </Space>
        ) : (
          ""
        ),
    },
  ];

  render(): React.ReactNode {
    const showTotal = (total: number, range: [number, number]): ReactNode => {
      return (
        <ul className="resultCount">
          <li className="grey">
            対象<span>{total}</span>
          </li>
        </ul>
      );
    };
    return (
      <Page title="ユーザ一覧" ref={this._page}>
        <div className="data_content">
          <Form
            name="user"
            colon={false}
            layout="horizontal"
            labelCol={{ span: 8 }}
            labelAlign="left"
            labelWrap={true}
            onFinish={this.onSearch}
            className="search_form"
            ref={this._form}
            initialValues={{
              universityCode: this.state.universityCode,
              facultyId: this.state.facultyId,
              departmentId: this.state.departmentId,
              majorId: this.state.majorId,
              courceId: this.state.courceId,
              seiMei: this.state.seiMei,
              seiMeiKana: this.state.seiMeiKana,
              userTypeCode: this.state.userTypeCode,
              mailAddress: this.state.mailAddress,
            }}
          >
            <Row>
              {this.context.user.userTypeCode === userTypeCodeODK_SU && (
                <Col span={6}>
                  <Form.Item
                    label="大学"
                    name="universityCode"
                    rules={[{ required: true }]}
                  >
                    <CommonMasterSelect
                      masterType={1}
                      allowClear={false}
                      width={160}
                      onChange={this.onChangeUniversityCode}
                    />
                  </Form.Item>
                </Col>
              )}
              {this.context.user.userTypeCode !== userTypeCodeODK_SU && (
                <Col span={6}>
                  <Form.Item label="学部" name="facultyId">
                    <CommonMasterSelect
                      allowClear={true}
                      ucode={this.state.universityCode}
                      masterType={2}
                      width={160}
                      onChange={this.onChangeFacultyId}
                    />
                  </Form.Item>
                </Col>
              )}
              {this.context.user.userTypeCode !== userTypeCodeODK_SU && (
                <Col span={6}>
                  <Form.Item label="学科" name="departmentId">
                    <CommonMasterSelect
                      allowClear={true}
                      ucode={this.state.universityCode}
                      fid={this.state.facultyId}
                      masterType={3}
                      width={160}
                      onChange={this.onChangeDepartmentId}
                    />
                  </Form.Item>
                </Col>
              )}
              {this.context.user.userTypeCode !== userTypeCodeODK_SU && (
                <Col span={6}>
                  <Form.Item label="専攻" name="majorId">
                    <CommonMasterSelect
                      allowClear={true}
                      ucode={this.state.universityCode}
                      fid={this.state.departmentId}
                      masterType={4}
                      width={160}
                      onChange={this.onChangeMajorId}
                    />
                  </Form.Item>
                </Col>
              )}
              {this.context.user.userTypeCode !== userTypeCodeODK_SU && (
                <Col span={6}>
                  <Form.Item label="コース" name="courceId">
                    <CommonMasterSelect
                      allowClear={true}
                      ucode={this.state.universityCode}
                      fid={this.state.majorId}
                      masterType={5}
                      width={160}
                      onChange={this.onChangeCourceId}
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
            <Row>
              <Col span={6}>
                <Form.Item label="氏名" name="seiMei" rules={[{ max: 20 }]}>
                  <Input style={{ width: 160 }} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="氏名(カナ)"
                  name="seiMeiKana"
                  rules={[{ max: 20 }]}
                >
                  <Input style={{ width: 160 }} />
                </Form.Item>
              </Col>
              {this.context.user.userTypeCode !== userTypeCodeODK_SU && (
                <Col span={6}>
                  <Form.Item label="ユーザ種別" name="userTypeCode">
                    <CommonMasterSelect
                      masterType={6}
                      width={200}
                      onChange={this.onChangeUserTypeCode}
                      ucode="2"
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  label="メールアドレス"
                  labelCol={{ span: 4 }}
                  name="mailAddress"
                  rules={[{ max: 50 }]}
                >
                  <Input style={{ width: 420 }} />
                </Form.Item>
              </Col>
              <Col span={6} offset={6}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    検索
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>

          <Table
            rowKey={(record: any) => record.userId}
            bordered
            pagination={{
              position: ["topRight"],
              pageSize: this.state.pageSize,
              onShowSizeChange: (current, pageSize) => {
                this.setState({ page: 1, pageSize: pageSize });
              },
              onChange: (page, pageSize) => {
                this.setState({ page: page });
              },
              showTotal,
            }}
            columns={this.columns}
            dataSource={this.state.userList}
          />
        </div>
      </Page>
    );
  }
}

export default withRouterDom(UserList);
